import React, { useState } from "react";
import "./FormBank.css";
import CustomRadioExample from "./Components/CustomCheckExample";
import { Table } from "react-bootstrap";

const FormBank = (props) => {
  const [selectedTax, setSelectedTax] = useState({});

  const groupName = props.id ? `taxOption-${props.id}` : "taxOption";

  const handleRadioChange = (radioId, category) => {
    setSelectedTax((prev) => {
      const currentSelected = prev[props.id];
      const newSelection = currentSelected === radioId ? "" : radioId;

      if (props.onSelect) {
        props.onSelect(newSelection, category);
      }

      return {
        ...prev,
        [props.id]: newSelection,
      };
    });
  };

  const renderTaxField = (taxName, taxValue, category, radioId) => {
    if (!taxName || !taxValue) return null;
    return (
      <td key={radioId}>
        <label
          htmlFor={radioId}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            cursor: "pointer",
            userSelect: "none",
          }}
        >
          <CustomRadioExample
            disabled={props.disabled}
            id={radioId}
            name={groupName}
            label={taxName}
            checked={selectedTax[props.id] === radioId}
            onClick={() => handleRadioChange(radioId, category)}
          />
          <TaxBadge value={taxValue} disable={props.disabled} />
        </label>
      </td>
    );
  };
  const TaxBadge = ({ value }) => <span className="tax-badge">{value}</span>;

  return (
    <Table
      bordered
      responsive
      variant={props.disabled ? "secondary" : undefined}
    >
      <tbody>
        <tr>
          <td style={{ width: "15%" }}>
            <div className="icon-container">
              <img
                src={props.src}
                alt="Ícone do Banco"
                height={props.height}
                width={props.width}
              />  
            </div>
          </td>

          {renderTaxField(
            props.firstNameTax,
            props.firstTax,
            "firstTax",
            props.firstId
          )}

          {renderTaxField(
            props.secondNameTax,
            props.secondTax,
            "secondTax",
            props.secondId
          )}

          {renderTaxField(
            props.thirdNameTax,
            props.thirdTax,
            "thirdTax",
            props.thirdId
          )}
          {renderTaxField(
            props.fourthNameTax,
            props.fourthTax,
            "fourthTax",
            props.fourthId
          )}
        </tr>
      </tbody>
    </Table>
  );
};

export default FormBank;
